
import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/glamping-family-reunions";
const TITLE = "Glamping Family Reunions in Arizona — Multi-Generational Stays | Backland";
const DESC =
  "Plan an unforgettable family reunion at Backland: connected luxury suites, family-friendly amenities, and 160 private acres of Northern Arizona pine forest for every generation.";
const OG_IMAGE =
  "/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/family-promo.jpg";

export const Route = createFileRoute("/glamping-family-reunions")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Family Reunions at Backland",
          serviceType: "Multi-generational family reunion glamping",
          url: URL,
          description: DESC,
          areaServed: { "@type": "State", name: "Arizona" },
          provider: {
            "@type": "LodgingBusiness",
            name: "Backland",
            address: { "@type": "PostalAddress", addressRegion: "AZ", addressCountry: "US" },
          },
        }),
      },
    ],
  }),
  component: FamilyReunionsRoute,
});

function FamilyReunionsRoute() {
  return <StoryExperience initialCategorySlug="groups" />;
}
